module.exports = "\r\n.modal-body .row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.Blue{\r\n    color:blue;    \r\n}\r\n\r\n.Green{\r\n    color:brown\r\n}\r\n\r\n.Red{\r\n    color:red;\r\n}\r\n\r\n.DGreen{\r\n    color: green\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/depart-enquiry/enquiry-closure/enquiry-closer-grid/enquiry-closer-grid.component.css
// module id = ./src/app/hrms/depart-enquiry/enquiry-closure/enquiry-closer-grid/enquiry-closer-grid.component.css
// module chunks = main